import api from './api';

/**
 * Tracciabilita' dei lotti.
 *
 * Le prime due le usa chi registra la prestazione; le altre due la
 * cartella clinica, dove il filtro di riservatezza lo applica il server.
 * La ricerca inversa e la regolarizzazione sono del front-desk.
 */
export const tracciabilitaAPI = {
    daIndicare: (visitaId) => api.get(`/tracciabilita/da-indicare/${visitaId}`),
    // `conferma` a true crea i lotti che non risultano a magazzino:
    // si passa solo dopo che una persona ha riletto l'etichetta
    registra: (righe, conferma = false) =>
        api.post('/tracciabilita/registra', { righe, conferma }),

    perVisita: (visitaId) => api.get(`/tracciabilita/visita/${visitaId}`),
    perPaziente: (pazienteId) => api.get(`/tracciabilita/paziente/${pazienteId}`),

    // Il motivo finisce nel registro degli accessi accanto a chi ha cercato
    perLotto: (codice, motivo) =>
        api.get(`/tracciabilita/lotto/${encodeURIComponent(codice)}`, { params: { motivo } }),
    daRegolarizzare: () => api.get('/tracciabilita/da-regolarizzare'),
    regolarizza: (lottoId, dati) => api.post(`/tracciabilita/regolarizza/${lottoId}`, dati),
    accessi: () => api.get('/tracciabilita/accessi'),
};

export default tracciabilitaAPI;
